import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { T, useTranslate } from '@tolgee/react'
import { AlertCircle } from 'lucide-react'

type DeleteDataAssetsDialogProps = Readonly<{
  open: boolean
  onOpenChange: (open: boolean) => void
  selectedCount: number
  onConfirm: () => void
  isLoading: boolean
}>

function DeleteDataAssetsDialog({
  open,
  onOpenChange,
  selectedCount,
  onConfirm,
  isLoading,
}: DeleteDataAssetsDialogProps) {
  const { t } = useTranslate()
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='sm:max-w-[425px]'>
        <DialogHeader>
          <DialogTitle className='flex items-start gap-2'>
            {selectedCount === 1 ? (
              <T keyName='dataCatalog.delete.title.single' />
            ) : (
              <T keyName='dataCatalog.delete.title.multiple' params={{ count: selectedCount }} />
            )}
          </DialogTitle>
          <DialogDescription className='flex flex-col gap-2'>
            <span className='flex items-start gap-4'>
              <AlertCircle className='mt-1 size-4 flex-shrink-0 text-error-300' />
              <span>
                <span className='block font-medium'>
                  <T keyName='dataCatalog.delete.alert' />
                </span>

                {selectedCount === 1 ? (
                  <T keyName='dataCatalog.delete.desc.single' />
                ) : (
                  <T keyName='dataCatalog.delete.desc.multiple' params={{ count: selectedCount }} />
                )}
              </span>
            </span>
            <T keyName='dataCatalog.delete.desc2' />
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            variant='mango-outline'
            title={t('shared.cancelDialog.a11y')}
            onClick={() => onOpenChange(false)}
            disabled={isLoading}
          >
            <T keyName='dataCatalog.delete.cancel' />
          </Button>
          <Button
            onClick={onConfirm}
            title={t('dataCatalog.delete.deleteButton.label')}
            loading={isLoading}
          >
            <T keyName='dataCatalog.delete.deleteButton.title' />
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export { DeleteDataAssetsDialog }
